import { observer } from 'mobx-react-lite'
import { match } from '@/utils/pattern-match-util'
import { ServiceTypeEmptyState, ServiceTypeList, ServiceTypeListItem } from './'
import { serviceTypeIcons } from '@/features/dashboard/service-type-icons'
import type { ServiceSelectionViewModel } from '@/features/dashboard/DashboardView/ServiceSelectionViewModel'
import type { LegendServiceType } from '@/features/jobs/legends/legend-service-type'

interface ServiceTypesContainerProps {
  vm: ServiceSelectionViewModel
  onStart: (type: LegendServiceType) => unknown
}

/**
 * The ServiceTypesContainer
 */
export const ServiceTypesContainer = observer(
  ({ vm, onStart }: ServiceTypesContainerProps) => {
    if (vm.availableServiceTypes.length === 0) {
      return <ServiceTypeEmptyState />
    }

    const isDisabled = vm.isPending
    return (
      <ServiceTypeList>
        {vm.availableServiceTypes.map((type) => {
          const isPending =
            vm.selectedServiceType === type && vm.createDraft.pending
          return match(type, {
            Tax: (
              <ServiceTypeListItem
                key={type}
                icon={serviceTypeIcons.Tax}
                title="Tax filing"
                description="File your personal or business taxes with expert support."
                isDisabled={isDisabled}
                onStart={() => onStart(type)}
                isPending={isPending}
                testId="service-types-tax-filing-item"
              />
            ),
            Consultation: (
              <ServiceTypeListItem
                key={type}
                icon={serviceTypeIcons.Consultation}
                title="Advisory"
                description="Schedule a call and get your questions answered from a Pro."
                isDisabled={isDisabled}
                isPending={isPending}
                onStart={() => onStart(type)}
                testId="service-types-consultation-item"
              />
            ),
            Bookkeeping: (
              <ServiceTypeListItem
                key={type}
                icon={serviceTypeIcons.Bookkeeping}
                title="Bookkeeping"
                description="Keep your finances organized and your books up-to-date."
                isDisabled={isDisabled}
                isPending={isPending}
                onStart={() => onStart(type)}
                testId="service-types-bookkeeping-item"
              />
            ),
            Misc: (
              <ServiceTypeListItem
                key={type}
                icon={serviceTypeIcons.Misc}
                title="Other services"
                description="Explore additional services tailored to your needs."
                isDisabled={isDisabled}
                isPending={isPending}
                onStart={() => onStart(type)}
                testId="service-types-misc-item"
              />
            ),
          })
        })}
      </ServiceTypeList>
    )
  },
)
